// extracted by mini-css-extract-plugin
export default {"form":"styles_form__IXXkY","form-items-row":"styles_form-items-row__xg3+V","onboarding-badge":"styles_onboarding-badge__xLDNe"};